<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Outras Entidades
                </span>
            </b-card-header>
            <b-card-body>
            <div>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    :itens="aportesParceiros"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-aporte-parceiro
                                v-if="$temAcessoView('CONV-OUT-ENT-01')"
                                :convenio="convenio"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-aporte-parceiro>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-atualizar-aporte-parceiro
                            class="text-danger float-left mr-1"
                            v-if="$temAcessoView('CONV-OUT-ENT-02')"
                            :convenio="convenio"
                            :aporteParceiro="data"
                            @atualizarLista="atualizarLista()">
                        </btn-atualizar-aporte-parceiro>
                        <btn-excluir-aporte-parceiro
                            class="text-danger float-left mr-1"
                            v-if="$temAcessoView('CONV-OUT-ENT-02')"
                            :convenio="convenio"
                            :aporteParceiro="data"
                            @atualizarLista="atualizarLista()"
                        ></btn-excluir-aporte-parceiro>
                    </template>
                    <template slot="valor" slot-scope="data">
                        {{ data.valor | currency }}
                    </template>
                </app-tabela>
            </div>  
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnInserirAporteParceiro from '../cadastro/outrasEntidades/BtnInserirAporteParceiro'
import BtnExcluirAporteParceiro from '../cadastro/outrasEntidades/BtnExcluirAporteParceiro'
import BtnAtualizarAporteParceiro from '../cadastro/outrasEntidades/BtnAtualizarAporteParceiro'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnInserirAporteParceiro,
        BtnAtualizarAporteParceiro,
        BtnExcluirAporteParceiro
    },

    data() {
        return {
            aportesParceiros: [],
            erros: [],
            mostrarTabela: false,
            campos: [
                {
                    key: 'cnpjFormatado',
                    label: 'CNPJ'
                },
                {
                    key: 'razaoSocial',
                    label: 'Razão Social'
                },
                {
                    key: 'nomeNatureza',
                    label: 'Natureza da Despesa'
                },
                {
                    key: 'nomeEvento',
                    label: 'Nome do Evento'
                },
                {
                    key: 'valor',
                    label: 'Valor'
                },
                {
                    key: 'formaAporteFormatado',
                    label: 'Forma de Aporte'
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.aportesParceiros = response.data.aportesParceiros
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.aportesParceiros = this.convenio.aportesParceiros
            }
        },
    },
}
</script>
